/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import React from 'react';

import { EOnboardingModalId } from '../../types/onboardingTypes';
import OnboardingModalFinal from './OnboardingModalFinal';
import OnboardingModalWelcome from './OnboardingModalWelcome';

export const onboardingModals: { [key in EOnboardingModalId]: React.ReactNode } = {
    [EOnboardingModalId.modalWelcome]: OnboardingModalWelcome,
    [EOnboardingModalId.modalFinal]: OnboardingModalFinal,
};
